export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LfahvYsAAAAAJUR-WQk4NeNnCYKo3uzoVhx4hUN',
  },

  //baseUrl: 'https://localhost:7249/api/'

  baseUrl: 'https://www.beefdirectpurchasersettlement.com/api/'
};

